import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AbstractComponent } from '@seb/web-common/core/components/cms/abstract-component.component';
import { PointOfServiceInterface } from '@seb/web-common/core/models/cms/point-of-service.interface';
import { StoreLocatorComponent } from '@seb/web-common/core/components/static/store-locator/store-locator.component';

@Component({
  selector: 'wc-point-of-service',
  templateUrl: './point-of-service.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    StoreLocatorComponent
  ]
})
export class PointOfServiceComponent extends AbstractComponent<PointOfServiceInterface> implements OnInit {
  title: string;
  posTypes: string[];
  posFeatures: string[];

  constructor() {
    super();
  }

  ngOnInit() {
    this.component$.subscribe((data: PointOfServiceInterface) => {
      this.title = data.headline;
      this.posTypes = data.posTypes.split(' ');
      this.posFeatures = this.parseStringArray(data.posFeatures);
    });
  }

  private parseStringArray(str: string): string[] {
    if (!str) {
      return [];
    }

    const quotedMatches = [...str.matchAll(/"([^"]*)"/g)].map((m) => m[1]);
    if (quotedMatches.length) {
      return quotedMatches;
    }

    return str
      .replace(/^\[|\]$/g, '')
      .split(',')
      .map((s) => s.trim());
  }
}
